module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list leaderboard-page"
  }, [_c('div', {
    staticClass: "breadcrumb"
  }, [_c('Breadcrumb', [_c('Breadcrumb-item', [_vm._v("外教招聘")]), _vm._v(" "), _c('Breadcrumb-item', [_vm._v("招聘龙虎榜")])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "page-head"
  }, [_c('h2', {
    staticClass: "page-title"
  }, [_vm._v("外教招聘龙虎榜")]), _vm._v(" "), _c('span', {
    staticClass: "page-badge"
  }, [_c('Icon', {
    attrs: {
      "type": "trophy"
    }
  }), _vm._v(" 招聘绩效")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "search"
  }, [_c('div', {
    staticClass: "lb-toolbar"
  }, [_c('span', {
    staticClass: "toolbar-label"
  }, [_vm._v("时间")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "88px"
    },
    attrs: {
      "transfer": "",
      "disabled": _vm.loading
    },
    on: {
      "on-change": _vm.onPeriodChange
    },
    model: {
      value: (_vm.period),
      callback: function($$v) {
        _vm.period = $$v
      },
      expression: "period"
    }
  }, _vm._l((_vm.periodOptions), function(item) {
    return _c('Option', {
      key: item.value,
      attrs: {
        "value": item.value
      }
    }, [_vm._v(_vm._s(item.label))])
  }), 1), _vm._v(" "), (_vm.period === 'day' || _vm.period === 'week') ? _c('DatePicker', {
    staticStyle: {
      "width": "150px",
      "margin-left": "8px"
    },
    attrs: {
      "type": "date",
      "format": "yyyy-MM-dd",
      "value": _vm.anchorDate,
      "clearable": false,
      "transfer": "",
      "disabled": _vm.loading,
      "title": _vm.period === 'week' ? '选择该周内任意一天，自动对齐到周一' : ''
    },
    on: {
      "on-change": _vm.onDateChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.period === 'month') ? _c('DatePicker', {
    staticStyle: {
      "width": "150px",
      "margin-left": "8px"
    },
    attrs: {
      "type": "month",
      "format": "yyyy-MM",
      "value": _vm.anchorDate,
      "clearable": false,
      "transfer": "",
      "disabled": _vm.loading
    },
    on: {
      "on-change": _vm.onDateChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.period === 'year') ? _c('DatePicker', {
    staticStyle: {
      "width": "150px",
      "margin-left": "8px"
    },
    attrs: {
      "type": "year",
      "format": "yyyy",
      "value": _vm.anchorDate,
      "clearable": false,
      "transfer": "",
      "disabled": _vm.loading
    },
    on: {
      "on-change": _vm.onDateChange
    }
  }) : _vm._e(), _vm._v(" "), (_vm.rangeText) ? _c('span', {
    staticClass: "toolbar-range"
  }, [_vm._v(_vm._s(_vm.rangeText))]) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "toolbar-label",
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_vm._v("HR")]), _vm._v(" "), _c('Select', {
    staticStyle: {
      "width": "140px"
    },
    attrs: {
      "placeholder": "全部",
      "clearable": "",
      "transfer": "",
      "disabled": _vm.loading
    },
    on: {
      "on-change": _vm.search
    },
    model: {
      value: (_vm.hr),
      callback: function($$v) {
        _vm.hr = $$v
      },
      expression: "hr"
    }
  }, _vm._l((_vm.hrOptions), function(item) {
    return _c('Option', {
      key: item.code,
      attrs: {
        "value": item.code
      }
    }, [_vm._v(_vm._s(item.text))])
  }), 1), _vm._v(" "), _c('Button', {
    staticStyle: {
      "margin-left": "12px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("查询")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "table-container"
  }, [_c('p', {
    staticClass: "table-tip"
  }, [_vm._v("按开课数倒序；新外教60天内离职量 ÷ 开课数 ≥ 15% 的行标红")]), _vm._v(" "), _c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.tableRows,
      "loading": _vm.loading,
      "row-class-name": _vm.rowClassName,
      "no-data-text": "暂无数据"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-037470b2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/teacher/recruit/TchRecruitLeaderboard.vue
// module id = 1594
// module chunks = 8